import { IQuestion, IAnswerOption, IQuestionSet } from "./main.interfaces";
import {
  AmountOfStructuredInputData,
  ApplicationsUsed,
  DecisionDifficulty,
  InputDataStructure,
  InputScanned,
  ProcessFrequency,
  ProcessPeaks,
  ProcessStability,
  ProcessSteps,
  RemoteDesktopApplication,
  ApplicationStability
} from "./assessment.calc";
import { i18n } from "../main";
export function getQuestions(): IQuestionSet {
  return {
    inputDataStructure: {
      questionType: i18n.t(
        "questionData.inputDataStructure.type"
      ) as string,
      questionText: i18n.t(
        "questionData.inputDataStructure.text"
      ) as string,
      questionExplanation: i18n.t(
        "questionData.inputDataStructure.explanation"
      ) as string,
      answerType: "enum",
      answerPossibilities: [
        {
          name: i18n.t(
            "questionData.inputDataStructure.answerPossibilities.notDigitalAndUnstructured"
          ) as string,
          value: InputDataStructure.NOT_DIGITAL_AND_UNSTRUCTURED
        },
        {
          name: i18n.t(
            "questionData.inputDataStructure.answerPossibilities.notDigitalAndStructured"
          ) as string,
          value: InputDataStructure.NOT_DIGITAL_AND_STRUCTURED
        },
        {
          name: i18n.t(
            "questionData.inputDataStructure.answerPossibilities.digitalAndUnstructured"
          ) as string,
          value: InputDataStructure.DIGITAL_AND_UNSTRUCTURED
        },
        {
          name: i18n.t(
            "questionData.inputDataStructure.answerPossibilities.digitalAndStructured"
          ) as string,
          value: InputDataStructure.DIGITAL_AND_STRUCTURED
        }
      ],
      answerValue: null
    },
    processStability: {
      questionType: i18n.t(
        "questionData.processStability.type"
      ) as string,
      questionText: i18n.t(
        "questionData.processStability.text"
      ) as string,
      questionExplanation: i18n.t(
        "questionData.processStability.explanation"
      ) as string,
      answerType: "enum",
      answerPossibilities: [
        {
          name: i18n.t(
            "questionData.processStability.answerPossibilities.noChange"
          ) as string,
          value: ProcessStability.NO_CHANGE
        },
        {
          name: i18n.t(
            "questionData.processStability.answerPossibilities.smallChange"
          ) as string,
          value: ProcessStability.SMALL_CHANGE
        },
        {
          name: i18n.t(
            "questionData.processStability.answerPossibilities.someChange"
          ) as string,
          value: ProcessStability.SOME_CHANGE
        },
        {
          name: i18n.t(
            "questionData.processStability.answerPossibilities.mediumChange"
          ) as string,
          value: ProcessStability.MEDIUM_CHANGE
        },
        {
          name: i18n.t(
            "questionData.processStability.answerPossibilities.significantChange"
          ) as string,
          value: ProcessStability.SIGNIFICANT_CHANGE
        }
      ],
      answerValue: null
    },
    applicationStability: {
      questionType: i18n.t(
        "questionData.applicationStability.type"
      ) as string,
      questionText: i18n.t(
        "questionData.applicationStability.text"
      ) as string,
      questionExplanation: i18n.t(
        "questionData.applicationStability.explanation"
      ) as string,
      answerType: "enum",
      answerPossibilities: [
        {
          name: i18n.t(
            "questionData.applicationStability.answerPossibilities.noChange"
          ) as string,
          value: ApplicationStability.NO_CHANGE
        },
        {
          name: i18n.t(
            "questionData.applicationStability.answerPossibilities.smallChange"
          ) as string,
          value: ApplicationStability.SMALL_CHANGE
        },
        {
          name: i18n.t(
            "questionData.applicationStability.answerPossibilities.someChange"
          ) as string,
          value: ApplicationStability.SOME_CHANGE
        },
        {
          name: i18n.t(
            "questionData.applicationStability.answerPossibilities.mediumChange"
          ) as string,
          value: ApplicationStability.MEDIUM_CHANGE
        },
        {
          name: i18n.t(
            "questionData.applicationStability.answerPossibilities.significantChange"
          ) as string,
          value: ApplicationStability.SIGNIFICANT_CHANGE
        }
      ],
      answerValue: null
    },
    processFrequency: {
      questionType: i18n.t(
        "questionData.processFrequency.type"
      ) as string,
      questionText: i18n.t(
        "questionData.processFrequency.text"
      ) as string,
      questionExplanation: i18n.t(
        "questionData.processFrequency.explanation"
      ) as string,
      answerType: "enum",
      answerPossibilities: [
        {
          name: i18n.tc(
            "questionData.processFrequency.answerPossibilities.daily",
            1
          ) as string,
          value: ProcessFrequency.DAILY
        },
        {
          name: i18n.tc(
            "questionData.processFrequency.answerPossibilities.daily",
            2
          ) as string,
          value: ProcessFrequency.DAILY * 2
        },
        {
          name: i18n.tc(
            "questionData.processFrequency.answerPossibilities.daily",
            3
          ) as string,
          value: ProcessFrequency.DAILY * 3
        },
        {
          name: i18n.tc(
            "questionData.processFrequency.answerPossibilities.daily",
            4
          ) as string,
          value: ProcessFrequency.DAILY * 4
        },
        {
          name: i18n.tc(
            "questionData.processFrequency.answerPossibilities.daily",
            5
          ) as string,
          value: ProcessFrequency.DAILY * 5
        },
        {
          name: i18n.tc(
            "questionData.processFrequency.answerPossibilities.daily",
            6
          ) as string,
          value: ProcessFrequency.DAILY * 6
        },
        {
          name: i18n.tc(
            "questionData.processFrequency.answerPossibilities.daily",
            7
          ) as string,
          value: ProcessFrequency.DAILY * 7
        },
        {
          name: i18n.tc(
            "questionData.processFrequency.answerPossibilities.daily",
            8
          ) as string,
          value: ProcessFrequency.DAILY * 8
        },
        {
          name: i18n.tc(
            "questionData.processFrequency.answerPossibilities.daily",
            9
          ) as string,
          value: ProcessFrequency.DAILY * 9
        },
        {
          name: i18n.tc(
            "questionData.processFrequency.answerPossibilities.daily",
            10
          ) as string,
          value: ProcessFrequency.DAILY * 10
        },
        {
          name: i18n.tc(
            "questionData.processFrequency.answerPossibilities.weekly",
            1
          ) as string,
          value: ProcessFrequency.WEEKLY
        },
        {
          name: i18n.tc(
            "questionData.processFrequency.answerPossibilities.weekly",
            2
          ) as string,
          value: ProcessFrequency.WEEKLY * 2
        },
        {
          name: i18n.tc(
            "questionData.processFrequency.answerPossibilities.weekly",
            3
          ) as string,
          value: ProcessFrequency.WEEKLY * 3
        },
        {
          name: i18n.tc(
            "questionData.processFrequency.answerPossibilities.weekly",
            4
          ) as string,
          value: ProcessFrequency.WEEKLY * 4
        },
        {
          name: i18n.tc(
            "questionData.processFrequency.answerPossibilities.monthly",
            1
          ) as string,
          value: ProcessFrequency.MONTHLY
        },
        {
          name: i18n.tc(
            "questionData.processFrequency.answerPossibilities.monthly",
            2
          ) as string,
          value: ProcessFrequency.MONTHLY * 2
        },
        {
          name: i18n.tc(
            "questionData.processFrequency.answerPossibilities.monthly",
            3
          ) as string,
          value: ProcessFrequency.MONTHLY * 3
        },
        {
          name: i18n.t(
            "questionData.processFrequency.answerPossibilities.quarterly"
          ) as string,
          value: ProcessFrequency.QUARTERLY
        },
        {
          name: i18n.t(
            "questionData.processFrequency.answerPossibilities.annualy"
          ) as string,
          value: ProcessFrequency.ANNUALLY
        }
      ],
      answerValue: null
    },
    frequencyVolume: {
      questionType: i18n.t(
        "questionData.frequencyVolume.type"
      ) as string,
      questionText: i18n.t(
        "questionData.frequencyVolume.text"
      ) as string,
      questionExplanation: i18n.t(
        "questionData.frequencyVolume.explanation"
      ) as string,
      answerType: "large_number",
      answerPossibilities: [],
      answerValue: null
    },
    averageRuntime: {
      questionType: i18n.t(
        "questionData.averageRuntime.type"
      ) as string,
      questionText: i18n.t(
        "questionData.averageRuntime.text"
      ) as string,
      questionExplanation: i18n.t(
        "questionData.averageRuntime.explanation"
      ) as string,
      answerType: "large_number",
      answerPossibilities: [],
      answerValue: null
    },
    humanErrorPercentage: {
      questionType: i18n.t(
        "questionData.humanErrorPercentage.type"
      ) as string,
      questionText: i18n.t(
        "questionData.humanErrorPercentage.text"
      ) as string,
      questionExplanation: i18n.t(
        "questionData.humanErrorPercentage.explanation"
      ) as string,
      answerType: "number",
      answerPossibilities: [],
      answerValue: null
    },
    processPeaks: {
      questionType: i18n.t("questionData.processPeaks.type") as string,
      questionText: i18n.t("questionData.processPeaks.text") as string,
      questionExplanation: i18n.t(
        "questionData.processPeaks.explanation"
      ) as string,
      answerType: "enum",
      answerPossibilities: [
        {
          name: i18n.t(
            "questionData.processPeaks.answerPossibilities.noPeaks"
          ) as string,
          value: ProcessPeaks.NO_PEAKS
        },
        {
          name: i18n.t(
            "questionData.processPeaks.answerPossibilities.regularPeaks"
          ) as string,
          value: ProcessPeaks.REGULAR_PEAKS
        },
        {
          name: i18n.t(
            "questionData.processPeaks.answerPossibilities.rareAndPredictable"
          ) as string,
          value: ProcessPeaks.RARE_AND_PREDICTABLE_PEAKS
        },
        {
          name: i18n.t(
            "questionData.processPeaks.answerPossibilities.rareAndUnpredictable"
          ) as string,
          value: ProcessPeaks.RARE_AND_UNPREDICTABLE_PEAKS
        }
      ],
      answerValue: null
    },
    processSteps: {
      questionType: i18n.t("questionData.processSteps.type") as string,
      questionText: i18n.t("questionData.processSteps.text") as string,
      questionExplanation: i18n.t(
        "questionData.processSteps.explanation"
      ) as string,
      answerType: "enum",
      answerPossibilities: [
        {
          name: i18n.t(
            "questionData.processSteps.answerPossibilities.lessThanTen"
          ) as string,
          value: ProcessSteps.LESS_THAN_TEN
        },
        {
          name: i18n.t(
            "questionData.processSteps.answerPossibilities.tenToFifteen"
          ) as string,
          value: ProcessSteps.TEN_TO_FIFTEEN
        },
        {
          name: i18n.t(
            "questionData.processSteps.answerPossibilities.fifteenToTwentyfive"
          ) as string,
          value: ProcessSteps.FIFTEEN_TO_TWENTYFIVE
        },
        {
          name: i18n.t(
            "questionData.processSteps.answerPossibilities.twentyfiveToFourty"
          ) as string,
          value: ProcessSteps.TWENTYFIVE_TO_FOURTY
        },
        {
          name: i18n.t(
            "questionData.processSteps.answerPossibilities.moreThanFourty"
          ) as string,
          value: ProcessSteps.MORE_THAN_FORTY
        }
      ],
      answerValue: null
    },
    decisionDifficulty: {
      questionType: i18n.t(
        "questionData.decisionDifficulty.type"
      ) as string,
      questionText: i18n.t(
        "questionData.decisionDifficulty.text"
      ) as string,
      questionExplanation: i18n.t(
        "questionData.decisionDifficulty.explanation"
      ) as string,
      answerType: "enum",
      answerPossibilities: [
        {
          name: i18n.t(
            "questionData.decisionDifficulty.answerPossibilities.complexDecisions"
          ) as string,
          value: DecisionDifficulty.COMPLEX_DECISIONS
        },
        {
          name: i18n.t(
            "questionData.decisionDifficulty.answerPossibilities.noDecisions"
          ) as string,
          value: DecisionDifficulty.NO_DECISIONS
        },
        {
          name: i18n.t(
            "questionData.decisionDifficulty.answerPossibilities.simpleDecisions"
          ) as string,
          value: DecisionDifficulty.SIMPLE_DECISIONS
        }
      ],
      answerValue: null
    },
    unfinishedProcessPercentage: {
      questionType: i18n.t(
        "questionData.unfinishedProcessPercentage.type"
      ) as string,
      questionText: i18n.t(
        "questionData.unfinishedProcessPercentage.text"
      ) as string,
      questionExplanation: i18n.t(
        "questionData.unfinishedProcessPercentage.explanation"
      ) as string,
      answerType: "number",
      answerPossibilities: [],
      answerValue: null
    },
    applicationsUsed: {
      questionType: i18n.t(
        "questionData.applicationsUsed.type"
      ) as string,
      questionText: i18n.t(
        "questionData.applicationsUsed.text"
      ) as string,
      questionExplanation: i18n.t(
        "questionData.applicationsUsed.explanation"
      ) as string,
      answerType: "enum",
      answerPossibilities: [
        {
          name: i18n.t(
            "questionData.applicationsUsed.answerPossibilities.one"
          ) as string,
          value: ApplicationsUsed.ONE
        },
        {
          name: i18n.t(
            "questionData.applicationsUsed.answerPossibilities.twoToThree"
          ) as string,
          value: ApplicationsUsed.TWO_TO_THREE
        },
        {
          name: i18n.t(
            "questionData.applicationsUsed.answerPossibilities.fourToFive"
          ) as string,
          value: ApplicationsUsed.FOUR_TO_FIVE
        },
        {
          name: i18n.t(
            "questionData.applicationsUsed.answerPossibilities.moreThanFive"
          ) as string,
          value: ApplicationsUsed.MORE_THAN_FIVE
        }
      ],
      answerValue: null
    },
    remoteDesktopApplication: {
      questionType: i18n.t(
        "questionData.remoteDesktopApplication.type"
      ) as string,
      questionText: i18n.t(
        "questionData.remoteDesktopApplication.text"
      ) as string,
      questionExplanation: i18n.t(
        "questionData.remoteDesktopApplication.explanation"
      ) as string,
      answerType: "enum",
      answerPossibilities: [
        {
          name: i18n.t(
            "questionData.remoteDesktopApplication.answerPossibilities.yes"
          ) as string,
          value: RemoteDesktopApplication.YES
        },
        {
          name: i18n.t(
            "questionData.remoteDesktopApplication.answerPossibilities.no"
          ) as string,
          value: RemoteDesktopApplication.NO
        }
      ],
      answerValue: null
    },
    digitalInputPercentage: {
      questionType: i18n.t(
        "questionData.digitalInputPercentage.type"
      ) as string,
      questionText: i18n.t(
        "questionData.digitalInputPercentage.text"
      ) as string,
      questionExplanation: i18n.t(
        "questionData.digitalInputPercentage.explanation"
      ) as string,
      answerType: "number",
      answerPossibilities: [],
      answerValue: null
    },
    inputScanned: {
      questionType: i18n.t("questionData.inputScanned.type") as string,
      questionText: i18n.t("questionData.inputScanned.text") as string,
      questionExplanation: i18n.t(
        "questionData.inputScanned.explanation"
      ) as string,
      answerType: "enum",
      answerPossibilities: [
        {
          name: i18n.t(
            "questionData.inputScanned.answerPossibilities.yes"
          ) as string,
          value: InputScanned.YES
        },
        {
          name: i18n.t(
            "questionData.inputScanned.answerPossibilities.no"
          ) as string,
          value: InputScanned.NO
        }
      ],
      answerValue: null
    },
    amountOfStructuredInputData: {
      questionType: i18n.t(
        "questionData.amountOfStructuredInputData.type"
      ) as string,
      questionText: i18n.t(
        "questionData.amountOfStructuredInputData.text"
      ) as string,
      questionExplanation: i18n.t(
        "questionData.amountOfStructuredInputData.explanation"
      ) as string,
      answerType: "enum",
      answerPossibilities: [
        {
          name: i18n.t(
            "questionData.amountOfStructuredInputData.answerPossibilities.smallerThanFourty"
          ) as string,
          value: AmountOfStructuredInputData.SMALLER_THAN_FORTY
        },
        {
          name: i18n.t(
            "questionData.amountOfStructuredInputData.answerPossibilities.fourtyToSixty"
          ) as string,
          value: AmountOfStructuredInputData.FORTY_TO_SIXTY
        },
        {
          name: i18n.t(
            "questionData.amountOfStructuredInputData.answerPossibilities.sixtyToEighty"
          ) as string,
          value: AmountOfStructuredInputData.SIXTY_TO_EIGHTY
        },
        {
          name: i18n.t(
            "questionData.amountOfStructuredInputData.answerPossibilities.biggerThanEighty"
          ) as string,
          value: AmountOfStructuredInputData.BIGGER_THAN_EIGHTY
        }
      ],
      answerValue: null
    }
  };
}
